<template>
  <div style="padding: 0 15px;" @click="toggleClick">
    <!-- <logo v-if="showLogo" :collapse="isCollapse"/> -->
    <svg :class="{ 'is-active': isActive }" v-if="device === 'mobile'" class="hamburger" viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg" width="128" height="128">
      <path
        d="M120.68157 169.880085 903.317407 169.880085 903.317407 299.796994 120.68157 299.796994 120.68157 169.880085Z"
        p-id="4780" fill="#337ab7"></path>
      <path
        d="M120.68157 429.714925 903.317407 429.714925 903.317407 561.197492 120.68157 561.197492 120.68157 429.714925Z"
        p-id="4781" fill="#337ab7"></path>
      <path
        d="M120.68157 691.115424 903.317407 691.115424 903.317407 821.032332 120.68157 821.032332 120.68157 691.115424Z"
        p-id="4782" fill="#337ab7"></path>
    </svg>
    <!-- <svg :class="{ 'is-active': isActive }" v-if="device === 'mobile'" class="hamburger" viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg" width="64" height="64">
      <path
        d="M120.68157 691.115424 903.317407 691.115424 903.317407 821.032332 120.68157 821.032332 120.68157 691.115424Z" />
    </svg> -->
    <span 
      v-if="showLogo" 
      style="
        font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', sans-serif;
        font-size: 14px;
        font-weight: 300;
        margin-left: 20px;
        color: #337AB7;
      "
    >
      云职友途
    </span>
  </div>
</template>

<script>
import Logo from '../../layout/components/Sidebar/Logo.vue'
import { mapGetters } from "vuex";

export default {
  name: 'Hamburger',
  components: { Logo },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleClick() {
      if (this.device !== 'mobile') {
        return;
      }
      this.$emit('toggleClick')
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    device() {
      return this.$store.state.app.device
    }
  }
}
</script>

<style scoped>
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}

.hamburger.is-active {
  transform: rotate(180deg);
}
</style>
